import React from "react";
import styles from "./style.module.scss";
import { useTranslation } from "next-i18next";
import { useAppContext } from "@kunduz/feature-website-context";
import { useQISimilarQuestions } from "@kunduz/feature-question-indexing";
import { trackEvent } from "@kunduz/utility-analytics";
import { getQIUrl } from "@kunduz/utility-common";

const PrevNextButtons = (props: Props) => {
  const LinkComponent = props.linkAs ?? "a";
  const { t } = useTranslation("questionIndexing");
  const { localeInfo } = useAppContext();
  const { similarQuestions, similarQuestionsError, similarQuestionsLoading } =
    useQISimilarQuestions(
      props.subjectSlug,
      localeInfo.locale?.iso.toLocaleLowerCase(),
    );

  function printPrev() {
    const prevQ = similarQuestions?.[0];
    function onPrevClicked(e) {
      trackEvent("Question Indexing Previous Question Button Clicked", {
        course: prevQ?.course?.name,
        subject: prevQ?.subject?.name,
        page_slug: prevQ?.slug,
      });
    }
    if (prevQ) {
      return (
        <LinkComponent
          className="btn"
          onClick={onPrevClicked}
          href={getQIUrl({
            lang: props.lang,
            questionSlug: prevQ.slug,
            questionId: prevQ.id,
          })}
        >
          {"<"} {t("question_indexing_question_previous_button")}
        </LinkComponent>
      );
    }
    return null;
  }
  function printNext() {
    const nextQ = similarQuestions?.[similarQuestions?.length - 1];
    function onNextClicked(e) {
      trackEvent("Question Indexing Next Question Button Clicked", {
        course: nextQ?.course?.name,
        subject: nextQ?.subject?.name,
        page_slug: nextQ?.slug,
      });
    }
    if (nextQ) {
      return (
        <LinkComponent
          className="btn"
          onClick={onNextClicked}
          href={getQIUrl({
            lang: props.lang,
            questionSlug: nextQ.slug,
            questionId: nextQ.id,
          })}
        >
          {t("question_indexing_question_next_button")} {">"}
        </LinkComponent>
      );
    }
    return null;
  }

  return (
    <div className={styles.wrapper}>
      {!similarQuestionsLoading && printPrev()}
      {!similarQuestionsLoading && printNext()}
    </div>
  );
};

interface Props {
  subjectSlug: string;
  lang: "tr" | "en";
  linkAs?: React.ElementType;
}

export default PrevNextButtons;
